import { UseFormReturnType } from "@mantine/form";
import { AdminProduct, Debtor } from "types/model.types";

import {
  AdminOrderEntry,
  CartItem,
  CreditNoteEntry,
  JournalEntry,
  ProductSummary,
  SupplierOrderEntry,
} from "./model.types";

export enum UserRole {
  Anonymous = "Anonymous",
  Customer = "Customers",
  Staff = "Staff",
  Administrator = "Administrators",
  SuperUser = "SuperUsers",
}

export interface IUser {
  id: string;
  name: string;
  role: UserRole;
  priceLevel: number;
}
export type User = IUser | null;

//Interfaces
interface IStyledNavigationProps {
  clicked: boolean;
  handleClick?: () => void;
}
export type StyledNavigationProps = IStyledNavigationProps;

export type ImageStyleProps = {
  width?: string;
  height?: string;
};

interface INavigationProps {
  onRouteChanged?: () => void;
}
interface INavigationDesktopProps extends INavigationProps {
  className?: string;
  position: string;
}
export type NavigationProps = INavigationProps;
export type NavigationDesktopProps = INavigationDesktopProps;

interface IPageProps {
  onChangeRoute?: (route: string) => void;
  resetCart?: () => void;
}
export type PageProps = IPageProps;
export type AdminPageProps = IPageProps;

interface IDialogProductPageProps extends IPageProps {
  open: boolean;
  product: ProductSummary | undefined;
  onClose: () => void;
  onSave: (p: ProductSummary | undefined) => void;
}
export type ProductDialogPageProps = IDialogProductPageProps;

export type RichEditorField = {
  content?: string;
  stale: boolean;
  role?: string;
  placeHolder?: string;
};

export type LookupDatum = {
  value: string;
  label: string;
};
export type LookupData = LookupDatum[];

export interface ISelectProps {
  defaultOption: LookupDatum | null;
  options: LookupData;
  onSelectionChanged: (selectedItem: LookupDatum | null) => void;
}

export type IAppStateProps = IPageProps;
export type ScreenProps = {
  width: number;
  height: number;
};
export type RichEditorRef = {
  getContent: () => string;
};

export type EditProductFormData = {
  initialize: boolean;
  brand: LookupDatum | null | undefined;
  category: LookupDatum | null | undefined;
  productDesc: string | undefined;
  detailedPhoto: string | undefined;
  featuredPhoto: string | undefined;
};
export type FileUploadPageProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  selectedFile: any;
};

export type JwtAuthData = {
  token: string;
  user: {
    email: string;
    role: string;
    priceLevel: number;
  };
};

export type LoginProps = {
  onLoginSuccessful: () => void;
  onRegisterRequest?: () => void;
  initializeCart?: () => void;
};
export interface IEmailNotification {
  id?: string;
  name: string;
  email: string;
  subject: string;
  message: string;
}

export type EmailNotification = IEmailNotification;
export type EmailNotifications = IEmailNotification[];

interface ICartButtonProps {
  added?: boolean;
  id?: string | number; // => WebProducts::Id (Guid)
  price: number;
  productCode: number;
  quantity: number;
  title: string;
  unitsCtn?: string;
  addItemToCart?: (item: CartItem) => void;
  removeItemFromCart?: (id: string) => void;
  onStateChanged?: () => void;
}

export type CartButtonProps = ICartButtonProps;

interface IChangePassword {
  oldPassword: string;
  newPassword: string;
}
export type ChangePassword = IChangePassword;

export interface IDataEntryFormProps {
  //knownInvoices: JournalEntries;
  onSaveComplete: (close: boolean) => void;
  onBeforeClose?: () => void; // called by parent.  if child is modal and user hits escape, we want to call this function first which will save and cleanup before closing modal.
  recordId: number | null; // null for new, populated for edit
}

interface IEntryRowProps<T> {
  entry: T;
  index?: number;
  isLastRow?: boolean;

  orderStage?: number;
  debtorPriceLevel?: number;

  onUpdate: (updated: T, forceCalc?: boolean) => void;
  onRemove: () => void;
  onNewEntry?: () => void;
}
interface IOrderEntryRowProps extends IEntryRowProps<SupplierOrderEntry> {
  orderReceived: boolean;
}
export type JournalEntryRowProps = IEntryRowProps<JournalEntry>;
export type CreditNoteEntryRowProps = IEntryRowProps<CreditNoteEntry>;
export type OrderEntryRowProps = IEntryRowProps<AdminOrderEntry>;
export type SupplierOrderEntryRowProps = IOrderEntryRowProps;
export type PaymentEntryRowProps = IEntryRowProps<JournalEntry>;

export type DebtorFormApi = Pick<
  UseFormReturnType<Debtor>,
  "values" | "setFieldValue" | "getInputProps"
>;

export type DebtorManagementChildFormProps = {
  readonly: boolean;
  formApi: DebtorFormApi;
};

export type ProductFormApi = Pick<
  UseFormReturnType<AdminProduct>,
  "values" | "setFieldValue" | "getInputProps"
>;

export type ProductManagementChildFormProps = {
  readonly: boolean;
  formApi: ProductFormApi;
};
